/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

export type RawSexEnumT = (typeof RawSexEnumT)[keyof typeof RawSexEnumT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RawSexEnumT = {
  male: "male",
  female: "female",
  other: "other",
  unknown: "unknown",
} as const;
